import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import FrameSettings from './../../components/FrameSettings'

const getSelectedIndex = state => dotProp.get(state, 'project.selectedIndex', -1)

const mapStateToProps = cb => state => ({
  width: dotProp.get(state, `project.pictures.${getSelectedIndex(state)}.width`, 0),
  height: dotProp.get(state, `project.pictures.${getSelectedIndex(state)}.height`, 0),
  isSidebarOpen: dotProp.get(state, 'sidebar.isClosed', false),
  show: cb(state),
})

const mapDispatchToProps = () => ({})

export default connect(
  mapStateToProps(state => dotProp.get(state, 'project.selectedObject', '') === 'frame'),
  mapDispatchToProps
)(FrameSettings)



// WEBPACK FOOTER //
// ./src/containers/FrameSettings/index.js